const NotFound: React.FC = () => {
  return <div>404 not found</div>
}

export default NotFound
